import { render, staticRenderFns } from "./MetricCategoryCreate.vue?vue&type=template&id=dbab3756"
import script from "./MetricCategoryCreate.vue?vue&type=script&lang=js"
export * from "./MetricCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports